var _line, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-11.501 -11.478 24 106.956",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.0000610352,
    x2: 0.5,
    y2: 84.0001,
    stroke: "#B6BAD1",
    strokeDasharray: "2 2",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -7.105427357601002e-15)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -4.999,
    y: -11.478,
    width: 11,
    height: 11,
    fill: "transparent",
    rx: 5.5,
    stroke: "#B6BAD1",
    style: {
      paintOrder: "stroke"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -7.105427357601002e-15)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: -11.501,
    y: 30.001,
    fill: "#F7F7F9",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -7.105427357601002e-15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.498 49.525 C -0.16 49.525 -0.69 48.988 -0.685 48.326 L -0.685 43.926 L -6.996 39.927 L -7.002 38.327 L -0.69 40.334 L -0.69 35.923 L -2.27 34.73 L -2.264 33.525 L 0.493 34.328 L 3.261 33.525 L 3.272 34.735 L 1.67 35.94 L 1.67 40.317 L 7.998 38.327 L 7.993 39.927 L 1.681 43.926 L 1.681 48.326 C 1.692 48.971 1.134 49.536 0.498 49.525 Z",
    fill: "#A6A8B6",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -7.105427357601002e-15)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 84.478,
    width: 11,
    height: 11,
    fill: "transparent",
    rx: 5.5,
    style: {
      stroke: "rgb(182, 186, 209)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -7.105427357601002e-15)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.079517fa9d308e8b5acf7f18d5ac0af1.svg";
export { ForwardRef as ReactComponent };